import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MembersPortalService } from '../../angular-wallet-base/services/members-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NavController, Platform, ToastController, IonBackButtonDelegate, ModalController, AlertController } from '@ionic/angular';
import { AppModeService } from '../../angular-wallet-base/services/app-mode.service';
import { getToastPosition, presentAlert, presentDltAlert } from '../../angular-wallet-base/utils';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { UpdateJwtAction } from 'src/app/angular-wallet-base/actions/userPreferences.actions';
import { ResetWalletWithAuthAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { StorageService } from 'src/app/angular-wallet-base/services/storage.service';
import { ShowSideMenu } from 'src/app/angular-wallet-base/actions/appSettings.actions';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-delete-account-page',
  templateUrl: './delete-account.page.html',
  styleUrls: ['./delete-account.page.scss'],
})
export class DeleteAccountPage implements OnInit, OnDestroy {
  public lodeUser;
  readonly deleteLandingPageId = 0;
  readonly confirmPageId = 1;
  readonly contactPageId = 2;
  public is2FAEnabled: boolean = false;
  public showPassword: boolean = false;
  public twofaCode: any = '';
  public password: any = '';
  public pageID: any = 0;
  public handleNavigation: any;
  public isDesktopMode: boolean;
  public loadingDeleteAccount: boolean = false;
  public endDate: any = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
  public dataCategory: Array<string> = ['location', 'transaction-history', 'phone-number', 'billing-address'];
  @ViewChild(IonBackButtonDelegate, { static: false }) backButton: IonBackButtonDelegate;

  constructor(
    private membersPortalService: MembersPortalService,
    private translate: TranslateService,
    private toast: ToastController,
    private alertController: AlertController,
    public appMode: AppModeService,
    public modal: ModalController,
    private platform: Platform,
    private nav: NavController,
    protected store: Store<AppState>,
    private authService: AuthService
  ) {
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  async ngOnInit() {
    this.lodeUser = await this.membersPortalService.getUserInfo();
    this.is2FAEnabled = Boolean(this.lodeUser.added_2fa_portal);
    if(this.lodeUser.two_factor =='sms'){
      this.is2FAEnabled = true;
      try {
        await this.membersPortalService.sendSmsToDisable2FA();
      } catch (error) {
        Logger.info(error)
      }
    }
    const ref = this;
    this.handleNavigation = () => {
      if (ref.pageID !== ref.deleteLandingPageId) {
        ref.pageID = ref.pageID - 1; // If not at delete landing page view, go to previous view by decrementing page Id 
      } else {
        ref.nav.pop();
      }
    };
    document.addEventListener('del-nav', this.handleNavigation);
  }

  ngOnDestroy() {
    document.removeEventListener('del-nav', this.handleNavigation);
  }

  ionViewDidEnter() {
    !this.isDesktopMode ? this.setUIBackButtonAction() : null;
  }

  setUIBackButtonAction() {
    this.backButton.onClick = () => {
      this.handleCancelClick();
    };
  }

  toggleshowPassword() {
    this.showPassword = !this.showPassword;
  }

  getListNames(param) {
    return 'lode_acc.delete_account.' + param;
  }

  getPageContentHandler(type) {
    let text = 'lode_acc.delete_account.';
    if (type === 'title') {
      text += this.pageID === this.confirmPageId ? 'are_you_sure' : 'label';
    } else if (type === 'info') {
      text += this.pageID === this.confirmPageId ? 'confirm_delete' : 'balance_info';
    } else {
      text += this.pageID === this.confirmPageId ? 'confirm_delete_btn' : 'contact_support';
    }
    return text;
  }

  handleSubmit() {
    switch (this.pageID) {
      case this.deleteLandingPageId:
        this.pageID = this.confirmPageId;
        break;
      case this.confirmPageId:
        this.deleteAccount();
        break;
      case this.contactPageId:
        this.openContact();
        break;
      default:
        this.nav.navigateForward(['/wallet/settings']);
    }
  }

  openContact() {
    const link = document.createElement('a');
    link.setAttribute('href', 'mailto:switch@lodepay.com');
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
  }

  returnFromDeletePage() {
    this.modal.dismiss();
  }
  closeModal() {
    this.modal.dismiss();
  }
  async deleteAccount() {
    try {
      this.loadingDeleteAccount = true;
      const response = await this.membersPortalService.deleteAccount(this.password, this.twofaCode);
      if (response.status === 1) {
        const handler = async () => {
          await this.authService.logoutAccount();
          await this.nav.navigateRoot('setup/intro');
        };
        const description = response.message;
        await presentDltAlert(this.alertController, handler, 'Delete Account', description, 'OK');
        this.closeModal();
      }
      this.loadingDeleteAccount = false;
    } catch (err) {
      if (err.error.error_code) {
        let errMsg;
        if (err.error.error_code === 'invalid_credentials' || err.error.error_code === '2fa_invalid') {
          errMsg = `lode_acc.delete_account.${err.error.error_code}`;
          this.pageID = this.deleteLandingPageId;
          this.twofaCode = '';
          this.password = '';
        } else if (err.error.error_code === 'hasHlfBalance') {
          errMsg = `lode_acc.delete_account.${err.error.error_code}`;
          this.pageID = this.contactPageId;
        } else {
          errMsg = 'lode_acc.delete_account.default_err_msg';
          this.pageID = this.deleteLandingPageId;
        }
        this.presentToast('settings.toast_msgs.err_hdr', errMsg);
      }
      this.loadingDeleteAccount = false;
    }
  }

  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000,
    });
    await toast.present();
  }

  handleCancelClick() {
    if (this.pageID === this.deleteLandingPageId) {
      this.returnFromDeletePage();
    } else {
      this.pageID = this.pageID - 1; // If not at delete landing page view, go to previous view by decrementing page Id 
    }
  }
}
